import { useState } from 'react';
import Button from '@mui/material/Button';
import { CONTACT_US_URL } from '../../utils/constants';
import PropTypes from 'prop-types';

const ErrorScreen = ({ error }) => {
  const [showDetails, setShowDetails] = useState(false);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const copyDetails = () => {
    navigator.clipboard.writeText(error.stack);
  };

  return (
    <div className="full-page-wrapper" style={{ maxWidth: 1000 }}>
      <h2>Sorry, something went wrong...</h2>

      {error.message && <p>Error: {error.message}</p>}

      {error.stack && (
        <>
          {showDetails && (
            <div>
              <textarea style={{ minWidth: 1000, height: 250 }}>{error.stack}</textarea>
            </div>
          )}
          <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
            <Button className="button-class cancel-btton" onClick={toggleDetails}>
              {showDetails ? 'Hide' : 'View'} Full Details
            </Button>
            {showDetails && (
              <Button className="button-class confirm-btton" onClick={copyDetails}>
                Copy Error Details
              </Button>
            )}
          </div>
        </>
      )}

      <p>
        Please refresh to try again. If you continue to have issues, please{' '}
        <a href={CONTACT_US_URL} target="blank" rel="noopener noreferrer">
          contact us
        </a>
        .
      </p>
    </div>
  );
};

ErrorScreen.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    stack: PropTypes.string,
  }).isRequired,
};

export default ErrorScreen;
